module.exports = __webpack_public_path__ + "img/15.3.TP.4eb793b9.png";